(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds  = {};
      this.currentScrollTop = 0;
      this.preventReveal    = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.setHeaderHeight();
      this._resizeObserver = new ResizeObserver(() => { this.setHeaderHeight(); this.createObserver(); });
      this._resizeObserver.observe(this.header);
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();
    }
    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    createObserver() {
      if (!this.header) return;
      if (this._intersectionObserver) this._intersectionObserver.disconnect();
      this._intersectionObserver = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        this._intersectionObserver.disconnect();
      });
      this._intersectionObserver.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      this.header.classList.toggle('scrolled-past-header', scrollTop > 50);
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); this.header.classList.remove('shopify-section-header-hidden'); }
      } else if (scrollTop <= this.headerBounds.top) {
        if (!this.headerIsAlwaysSticky) this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.currentScrollTop = scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
